var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { getJson, postObjectJson } from '../utility/request';
export const fetchAdminNotifications = (opts = {}) => {
    const qs = new URLSearchParams();
    if (opts.unreadOnly !== undefined) {
        qs.set('unreadOnly', String(opts.unreadOnly));
    }
    if (opts.limit !== undefined) {
        qs.set('limit', String(opts.limit));
    }
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return getJson(`/admin/notifications${suffix}`);
};
export const fetchAdminUnreadCount = () => getJson(`/admin/notifications/unread-count`).then((r) => r.count);
export const markAdminNotificationRead = (id) => __awaiter(void 0, void 0, void 0, function* () {
    yield postObjectJson(`/admin/notifications/${id}/read`, {});
});
export const markAdminInvoiceRead = (invoiceId) => __awaiter(void 0, void 0, void 0, function* () {
    yield postObjectJson(`/admin/notifications/mark-invoice-read/${invoiceId}`, {});
});
// Label + icon shown for each known alert type. Unknown types render a
// generic "Alert" row with the fallback bell icon.
export const alertTypeMeta = (alertType) => {
    switch (alertType) {
        case 'estimate_approved': return { 'label': 'Estimate approved', 'icon': 'task_alt' };
        case 'paylink_paid': return { 'label': 'Payment received', 'icon': 'credit_score' };
        case 'paylink_declined': return { 'label': 'Payment declined', 'icon': 'credit_card_off' };
        default: return { 'label': 'Alert', 'icon': 'notifications' };
    }
};
// Polling hook. Returns the current unread count + a refetch function so
// callers can force a refresh immediately after a mark-read action instead
// of waiting out the next poll.
export const useAdminUnreadCount = (intervalMs = 15000) => {
    const [count, setCount] = React.useState(0);
    const cancelledRef = React.useRef(false);
    const refetch = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const n = yield fetchAdminUnreadCount();
            if (!cancelledRef.current) {
                setCount(n);
            }
        }
        catch ( /* swallow transient errors so one failed poll does not kill the loop */_a) { /* swallow transient errors so one failed poll does not kill the loop */ }
    }), []);
    React.useEffect(() => {
        cancelledRef.current = false;
        void refetch();
        const timer = setInterval(() => { void refetch(); }, intervalMs);
        return () => { cancelledRef.current = true; clearInterval(timer); };
    }, [intervalMs, refetch]);
    return { count, refetch };
};
// Optimistic mark-read: drops the row from the local list immediately and marks
// the server read in the background, then refreshes the badge once the server
// has confirmed. Isolated here so every consumer of AdminNotification can share
// the same pattern.
export const useMarkAdminNotificationRead = (refetchUnread) => React.useCallback((setItems, id) => __awaiter(void 0, void 0, void 0, function* () {
    setItems((prev) => prev ? prev.filter((x) => x.id !== id) : prev);
    try {
        yield markAdminNotificationRead(id);
    }
    finally {
        void refetchUnread();
    }
}), [refetchUnread]);
